import { Grid } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AppContext } from '../../../app-context';
import IForm from '../../../components/i-form/i-form.component';
import ITextField from '../../../components/text-component/textfield/i-textfield.component';
import { isNotNull } from '../../common/util.services';
import { getCustomerById, saveCustomer } from '../customer.services';
import './customer-form.component.scss';
import { CUSTOMER_TYPE_SELECT_ITEMS, PRODUCT_SELECT_ITEMS } from '../../common/constants';
import IMultiSelect from '../../../components/text-component/multiselect/i-multiselect.component';

const CustomerForm = (props: any) => {
  const [title, setTitle] = useState<string>('Add Customer');
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const params = useParams()
  const rowId = params.rowId;
  const [customerData, setCustomerData] = useState<any>({products:[], type:[]});
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    if (isNotNull(rowId)) {
      getCustomerById(rowId, appContext,
        (response: any) => {
          setTitle('Edit Customer');
          setCustomerData(response.data);
          setLoader(false);
          appContext.setShowLoader(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          setLoader(false);
        });
    } else {
      setLoader(false);
    }
  }, []);

  const onSubmit = (data: any) => {
    saveCustomer(data, appContext,
      (response: any) => {
        navigate('/customer/list');
        appContext.setSuccessMessage(response.message)
        appContext.setShowLoader(false);
      }, (error: any) => {
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message)
      });
  }

  const getMainComponent = () => {
    return <Grid container spacing={1}>
      <Grid xs={3}>
        <ITextField name='name' label='Name' required={true} disabled={isNotNull(rowId)} />
      </Grid>
      <Grid xs={3}>
        <ITextField name='code' label='Code' required={true} />
      </Grid>
      <Grid xs={3}>
        <ITextField name='primaryContact' label='Primary Contact' required={true} />
      </Grid>
      <Grid xs={3}>
        <ITextField type="phone" name='primaryNumber' label='Primary Number' required={true} />
      </Grid>
      <Grid xs={3}>
        <ITextField type="email" name='primaryMail' label='Primary Mail' required={true} />
      </Grid>
      <Grid xs={3}>
        <ITextField name='secondaryContact' label='Secondary Contact' />
      </Grid>
      <Grid xs={3}>
        <ITextField type="phone" name='secondaryNumber' label='Secondary Number' />
      </Grid>
      <Grid xs={3}>
        <ITextField type="email" name='secondaryMail' label='Secondary Mail' />
      </Grid>
      <Grid xs={3}>
        <ITextField name='site' label='Site' />
      </Grid>
      <Grid xs={1.5}>
        <IMultiSelect name='products' label='Products' required={true} itemList={PRODUCT_SELECT_ITEMS}/>
      </Grid>
      <Grid xs={1.5}>
        <IMultiSelect name='type' label='Type' required={true} itemList={CUSTOMER_TYPE_SELECT_ITEMS}/>
      </Grid>
      <Grid xs={3}>
        <ITextField name='city' label='City' required={true}/>
      </Grid>
      <Grid xs={3}>
        <ITextField name='country' label='Country' required={true}/>
      </Grid>
      <Grid xs={3}>
        <ITextField name='gst' label='GST Number' />
      </Grid>
      <Grid xs={3}>
        <ITextField name='address1' label='Address 1' required={true} />
      </Grid>
      <Grid xs={3}>
        <ITextField name='address2' label='Address 2' required={true} />
      </Grid>
      <Grid xs={3}>
        <ITextField name='address3' label='Address 3' required={true} />
      </Grid>
    </Grid>
  }

  return loader ? <></> : <IForm formData={customerData} title={title} submitForm={onSubmit} mainComponent={getMainComponent()}></IForm>
}

export default CustomerForm;